function NavIcon({ name }) {
  const iconProps = {
    'aria-hidden': 'true',
    className: 'nav-icon',
    fill: 'none',
    viewBox: '0 0 24 24',
    xmlns: 'http://www.w3.org/2000/svg',
  };

  if (name === 'search') {
    return (
      <svg {...iconProps}>
        <path d="m19.5 19.5-4.2-4.2M10.5 17a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13ZM8 10.5h5" />
      </svg>
    );
  }

  if (name === 'community') {
    return (
      <svg {...iconProps}>
        <path d="M6.2 15.8 3.8 18V5.8c0-.8.7-1.5 1.5-1.5h10.4c.8 0 1.5.7 1.5 1.5v7c0 .8-.7 1.5-1.5 1.5H8.1l-1.9 1.5ZM9.5 18.2h6.4l2.3 1.8v-9.5M7.5 8.2h6M7.5 11h4.2" />
      </svg>
    );
  }

  if (name === 'grid') {
    return (
      <svg {...iconProps}>
        <path d="M4 5.5C4 4.7 4.7 4 5.5 4h4C10.3 4 11 4.7 11 5.5v4c0 .8-.7 1.5-1.5 1.5h-4C4.7 11 4 10.3 4 9.5v-4ZM13 5.5c0-.8.7-1.5 1.5-1.5h4c.8 0 1.5.7 1.5 1.5v4c0 .8-.7 1.5-1.5 1.5h-4c-.8 0-1.5-.7-1.5-1.5v-4ZM4 14.5c0-.8.7-1.5 1.5-1.5h4c.8 0 1.5.7 1.5 1.5v4c0 .8-.7 1.5-1.5 1.5h-4C4.7 20 4 19.3 4 18.5v-4ZM13 14.5c0-.8.7-1.5 1.5-1.5h4c.8 0 1.5.7 1.5 1.5v4c0 .8-.7 1.5-1.5 1.5h-4c-.8 0-1.5-.7-1.5-1.5v-4Z" />
      </svg>
    );
  }

  if (name === 'notice') {
    return (
      <svg {...iconProps}>
        <path d="M7 5.5h10M7 10h10M7 14.5h6M5.5 3.5h13c.8 0 1.5.7 1.5 1.5v11c0 .8-.7 1.5-1.5 1.5H9l-4.5 3v-15c0-.8.7-1.5 1.5-1.5Z" />
      </svg>
    );
  }

  if (name === 'user') {
    return (
      <svg {...iconProps}>
        <path d="M12 12.5A4.2 4.2 0 1 0 12 4a4.2 4.2 0 0 0 0 8.5ZM4.5 20c.8-3.4 3.7-5.5 7.5-5.5s6.7 2.1 7.5 5.5" />
      </svg>
    );
  }

  if (name === 'partner') {
    return (
      <svg {...iconProps}>
        <path d="M8 10.5A3.2 3.2 0 1 0 8 4.1a3.2 3.2 0 0 0 0 6.4ZM16.6 11a2.8 2.8 0 1 0 0-5.6 2.8 2.8 0 0 0 0 5.6ZM3.5 19.5c.5-3.4 2.2-5.6 4.8-5.6s4.3 2.2 4.8 5.6M13.2 15.1c.8-.8 1.8-1.2 3-1.2 2.3 0 3.8 2 4.3 5.2" />
      </svg>
    );
  }

  if (name === 'support') {
    return (
      <svg {...iconProps}>
        <path d="M5 12a7 7 0 0 1 14 0v3.5c0 .9-.7 1.5-1.5 1.5H16v-5h3M5 12h3v5H6.5c-.8 0-1.5-.6-1.5-1.5V12ZM9.5 19.5h3.2c1.8 0 3.3-1 3.3-2.5" />
      </svg>
    );
  }

  return (
    <svg {...iconProps}>
      <path d="m4.5 11 7.5-7 7.5 7M6.5 10v9.5h4v-5h3v5h4V10" />
    </svg>
  );
}

export default NavIcon;
